// @flow
import { handleResponseWithNon200Errors, makeGet } from './helpers';

type FetchCityAndStateByZipParams = {
    authToken: string,
    deployment: string,
    zipcode: string,
};

export const fetchCityStateSuggestion = ({ authToken, deployment, zipcode }: FetchCityAndStateByZipParams) =>
    new Promise<any>((resolve, reject) => {
        const request = makeGet({
            apiPath: 'zipcodecity',
            authToken,
            deployment,
            path: '<ITEM-API>',
            queryParams: { zipcode },
        });
        request.end((err, response) => handleResponseWithNon200Errors({ err, reject, resolve, response }));
    });
